const USER_ID_KEY = 'userID'

/**
 * Persists user id in client side storage
 */
export const storeUserId = (userId: string) =>
  localStorage.setItem(USER_ID_KEY, userId)

/** Returns true if a user id is found in storage */
export const hasStoredUserId = () => Boolean(localStorage.getItem(USER_ID_KEY))

/**
 * Returns stored user id string
 */
export const readStoredUserId = () => localStorage.getItem(USER_ID_KEY) || ''
